module.exports = __webpack_public_path__ + "img/icon-arrow.1bc92f7f.svg";